export const isArchived = (status?: string | null) => status === "ARCHIVED";

export const formatEntityStatus = (status?: string | null) =>
  status ? status.replace(/_/g, " ") : "—";
